import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.WorkflowIdPage.WorkflowSettingsPopupContent.SectionBalanceControlCheck', {
    title: 'Balance control',
    subtitle:
        'When the available balance in the connected bank account is not enough to cover the payment, the system should:',
    allow: 'Allow sending payments (useful for overdraft accounts)',
    disallow: 'Do not allow sending payments when funds are insufficient',
});
